export default __webpack_public_path__ + "static/media/infinitytale.923f1d87.png";